import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../config";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      localStorage.setItem("resetEmail", email);
      navigate("/verify");
    } catch (err) {
      toast.error("Failed to send password reset email. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1F9BFF1A] flex flex-col md:flex-row">
      {/* Left side - Forgot Password form */}
      <div className="w-full md:w-2/5 flex items-center justify-center">
        <div className="max-w-lg w-full space-y-8 bg-white p-6 md:p-14 rounded-2xl shadow-lg border border-gray-200 m-4 md:m-6 min-h-[550px] flex items-center justify-center relative">
          <button
            onClick={() => navigate("/")}
            className="absolute top-4 md:top-6 left-4 md:left-6 text-gray-600 hover:text-gray-800 text-xl"
          >
            &#8592;
          </button>
          <div className="flex flex-col items-center w-full px-4 md:px-0">
            <div className="self-start">
              <h2 className="text-3xl font-bold text-gray-800 mb-2">
                Forgot Password
              </h2>
              <p className="text-sm text-gray-600">
                Enter your email address and we'll send you a password reset
                link.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="mt-8 space-y-6 w-full">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-500"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="block w-full py-0.6 border-b border-gray-300 focus:border-b-2 focus:border-blue-500 focus:outline-none"
                />
              </div>
              <div className="flex justify-center items-center w-full">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full py-2 px-6 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#1F9BFF] hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center"
                >
                  {isLoading ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Processing...
                    </>
                  ) : (
                    "Continue"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Right side - Blue section with text and logo */}
      <div className="hidden md:flex w-3/5 bg-[#1F9BFF1A] flex-col items-center justify-center p-12 text-white">
        <div className="flex items-center justify-center w-full h-full">
          <img
            src="/Group.png"
            alt="Group"
            className="w-4/5 max-w-lg object-contain"
          />
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default ForgotPassword;
